import WorkflowStep from "./workflowStep";
import {WorkflowType} from "~/enums/forms/workflowSteps/workflowType";
import WorkflowStepInterface from "../../../../common/interfaces/workflowStepInterface";
import Validatable from "../../../../common/mixins/validatable";
import FormSectionFactory from "../formSections/formSectionFactory";
import ProcessFlowWorkflowStepValidation from "~/models/navigableValidations/processFlowWorkflowStepValidation";

export default class ProcessFlowWorkflowStep extends Validatable(WorkflowStep) implements WorkflowStepInterface {
  constructor(form?) {
    super(form);
    this.defineProperty('workflow_type', WorkflowType.processFlow);
    this.defineProperty('has_form_section', false)
  }

  //***** validation ***** //
  _validation: ProcessFlowWorkflowStepValidation = new ProcessFlowWorkflowStepValidation(this);

  get titleOrDefault(): string {
    if (this.hasTitle) {
      return this.title;
    } else {
      return `Run a Process`;
    }
  }

  createFormSection(): void {
    if (!this.form_section) {
      this.form_section = FormSectionFactory.create(this);
      this.trackCreationDeletion(this.form_section.client_id, null, this.form_section.asJson(), this.form_section);
    }
  }

}